/**
 * 
 */
export default class RestApi {
  test = {
    test: () => $app.api.get([ 'test', ]),
  }
  
  auth = {
    login: (data) => $app.api.post([ 'auth/login', ]).data(data),
    info: () => $app.api.get([ 'auth/info', ]),
  }
  
  branches = {
    get: (id) => $app.api.get([ 'branches*', id, ]),
  }

  users = {
    get: (id) => $app.api.get([ 'users*', id, ]),
    getKln: () => $app.api.get([ 'kln-users', ]),
    getTimer: () => $app.api.get([ 'timer-users', ]),

  }

  categories = {
    get: (id) => $app.api.get([ 'categories*', id, ]).all(),
    getSubCategories: (id) => $app.api.get([ 'categories*/subcategories', id, ]).all(),
  }

  quizzes = {
    get: (categoryId) => $app.api.get([ 'kln/categories*/quizzes', categoryId, ]).all(),
  }

  questions = {
    get: (id) => $app.api.get([ 'kln/quizzes*/questions', id, ]).all(),
  }

  timercategories = {
    get: (id) => $app.api.get([ 'timer-categories*', id, ]),
    getAll: (id) => $app.api.get([ 'admin/timer-categories*', id, ]),
  }
  timerquizzes = {
    getAll: (categoryId) => $app.api.get([ 'kln/admin/timer-categories*/timer-quizzes', categoryId, ]),
    get: (categoryId) => $app.api.get([ 'kln/timer-categories*/timer-quizzes', categoryId, ]).all(),
    getByCategory: (categoryId) => $app.api.get([ 'kln/timer-categories*/timer-quizzes', categoryId, ]),
  }
  timerquestions = {
    get: (id) => $app.api.get([ 'kln/timer-quizzes*/timer-questions', id, ]),
    getOne: (id) => $app.api.get([ 'kln/timer-questions*', id, ]),
    getByQuiz: (quizId) => $app.api.get([ 'kln/timer-quizzes*/timer-questions', quizId, ]),
  }
  timeranswers = {
    save: (resultId, quizId, data) => $app.api.post([ 'kln/timer-results*/timer-quizzes*/timer-answers', resultId, quizId, ]).data(data),
  }

  results = {
    get: (id) => $app.api.get([ 'kln/results*', id, ] ).all(),
    getOne: (id) => $app.api.get([ 'kln/results*', id, ] ),
    begin: (data) => $app.api.post([ 'kln/begin/results', ]).data(data),
    cancel: (id) => $app.api.delete([ 'kln/results*/cancel', id, ]),
    patch: (id, data) => $app.api.patch([ 'kln/results*', id, ]).data(data),
    remake: (id) => $app.api.patch([ 'kln/results*/remake', id, ]),
  }

  timerresults = {
    get: (id) => $app.api.get([ 'kln/timer-results*', id, ] ).all(),
    getOne: (id) => $app.api.get([ 'kln/timer-results*', id, ] ),
    begin: (data) => $app.api.post([ 'kln/begin/timer-results', ]).data(data),
    cancel: (id) => $app.api.delete([ 'kln/timer-results*/cancel', id, ]),
    patch: (id, data) => $app.api.patch([ 'kln/timer-results*', id, ]).data(data),
    remake: (id) => $app.api.patch([ 'kln/timer-results*/remake', id, ]),
  }

  timer = {
    get: (id) => $app.api.get([ 'kln/results*', id, ] ).all(),
    begin: (data) => $app.api.post([ 'kln/begin/timer', ]).data(data),

  }

  answers = {
    save: (resultId, quizId, data) => $app.api.post([ 'kln/results*/quizzes*/answers', resultId, quizId, ]).data(data),
  }
}
